import React from "react";
import {
    DataGrid, GridCellParams,
    GridColDef, GridOverlay,
} from "@material-ui/data-grid";
import moment from "moment";
import useRegisterExit from "../../../hooks/useRegisterExit";
import {useStore} from "../../../hooks/useStore";
import {useTranslation} from "../../../hooks/useTranslation";
import CustomFooterGrid from "../../common/CustomFooterGrid";
import {Tooltip} from "../../common/Tooltip";
import {useStyles} from "./RegisterExitDataStyle";
import {LinearProgress} from "@material-ui/core";
import {formatComments, renderCellWithEllipsis} from "../../../utils/FormatString";
import {setPaginationPage, setSortBy, setSortByDirection} from "../../../redux/actions/registerExitActions";
import {useDispatch} from "react-redux";

const convertDataTable = (peopleInside: any[]): any[] => {
  return peopleInside.map((item) => {
    return {
      id: item.id,
      lotNumber: item.event?.lotNumbers
          ? item.event.lotNumbers.toString().replaceAll(",", "\n")
          : "",
      hostName: `${item.firstname} ${item.lastname}`,
      dni: item.dni,
      plate: item.event.vehicle ? item.event.vehicle.plate : "",
      dateOfEntry: moment(item.event.datetime).format("DD-MMM HH:mm") + " hs",
      comments: formatComments(item.event.peopleComment, item.event.comment),
    };
  });
};

const RegisterExitData = () => {
  const classes = useStyles();
  const { openRegister } = useRegisterExit();
  const { t, BundleKey } = useTranslation();
  const { registerExitStore } = useStore();
  const { fetchPeopleInside } = useRegisterExit();
  const dispatch = useDispatch();

  const onSelect = (data: any) => {
    let userSelected: any = registerExitStore.listPeopleInside.find(
      (event: any) => event.id === data.id
    );
    if (userSelected) {
      openRegister(userSelected);
    }
  };

  const columns: GridColDef[] = [
    {
      field: "lotNumber",
      headerClassName: "super-app-theme--header " + classes.cellLot,
      headerName: t(BundleKey.REGISTEREXIT_GRID_HEAD_LOT),
      cellClassName: classes.cell + " " + classes.cellLot,
      description: "Numero de lote de la solicitud",
      disableColumnMenu: true,
      renderCell: (params) => <Tooltip bold value={params.value} />,
      sortable: false,
    },
    {
      field: "hostName",
      headerClassName: "super-app-theme--header " + classes.cellGuest,
      headerName: t(BundleKey.REGISTEREXIT_GRID_HEAD_NANE),
      cellClassName: classes.cell + " " + classes.cellGuest,
      description: "Nombre del ingresante",
      disableColumnMenu: true,
      renderCell: (params) => <Tooltip bold value={params.value} />,
      sortable: false,
    },
    {
      field: "dni",
      headerClassName: "super-app-theme--header " + classes.cellDni,
      headerName: t(BundleKey.REGISTEREXIT_GRID_HEAD_DNI),
      cellClassName: classes.cell + " " + classes.cellDni,
      description: "Nombre del solicitante del pase",
      disableColumnMenu: true,
      renderCell: (params) => <Tooltip bold value={params.value} />,
      sortable: false,
    },
    {
      field: "plate",
      headerClassName: "super-app-theme--header " + classes.cellPlate,
      headerName: t(BundleKey.REGISTEREXIT_GRID_HEAD_PLATE),
      cellClassName: classes.cell + " " + classes.cellPlate,
      description: "Patente del vehiculo ingresante",
      disableColumnMenu: true,
      renderCell: (params) => <Tooltip value={params.value} />,
      sortable: false,
    },
    {
      field: "dateOfEntry",
      headerClassName: "super-app-theme--header " + classes.dateOfEntry,
      headerName: t(BundleKey.REGISTEREXIT_GRID_HEAD_DATE),
      cellClassName: classes.cell + " " + classes.dateOfEntry,
      description: "Fecha y hora del pase",
      disableColumnMenu: true,
      renderCell: (params) => <Tooltip value={params.value} />,
      sortable: true,
    },
    {
      field: "comments",
      headerClassName: "super-app-theme--header " + classes.cellComments,
      headerName: t(BundleKey.REGISTEREXIT_GRID_HEAD_OBSERVATIONS),
      cellClassName: classes.cell + " " + classes.cellComments,
      description: "Observaciones del evento",
      disableColumnMenu: true,
      renderCell: (params: GridCellParams) => {
        return(
            <Tooltip value={params.value}>
                {params.value &&
                    renderCellWithEllipsis(params.value.toString())
                }
            </Tooltip>
        )
      },
      sortable: false,
    },
  ];

  const CustomLoadingOverlay = () => (
      <GridOverlay>
        <div style={{position: "absolute", top: 0, width: "100%"}}>
          <LinearProgress />
        </div>
      </GridOverlay>
  )

  const handleSortModelChange = (model: any) => {
    if (model.sortModel.length > 0) {
      const sortField = model.sortModel[0].field;
      const sortDirection = model.sortModel[0].sort;

      // Call fetchPeopleInside with sorting parameters
      if (sortField === 'dateOfEntry') {
        fetchPeopleInside(0, '', sortField, sortDirection);
        // Reset pagination page to 0
        dispatch(setPaginationPage(0));
        // Set sort direction and sortBy
        dispatch(setSortBy(sortField));
        dispatch(setSortByDirection(sortDirection));
      }
    } else {
      // Handle the case when sorting is cleared
      fetchPeopleInside(0, '');
      // Reset pagination page to 0
      dispatch(setPaginationPage(0));
    }
  };

  return (
    <DataGrid
      className={classes.root}
      rows={convertDataTable(registerExitStore?.listPeopleInside)}
      columns={columns}
      onRowClick={(param) => onSelect(param.row)}
      localeText={{ noRowsLabel: t(BundleKey.REGISTEREXIT_NOTFOUND) }}
      components={{
        Footer: CustomFooterGrid,
        LoadingOverlay: CustomLoadingOverlay,
      }}
      loading={registerExitStore.loadingSearch}
      disableColumnFilter={true}
      onSortModelChange={(model) => handleSortModelChange(model)}
    />
  );
};

export default RegisterExitData;
